module.exports = __webpack_public_path__ + "media/images/common/ordermail_btn_l_ov-cbd1812fdd7ae4563c763906a1ae18e1.png";